import ButtonBack from '@/view/components/ButtonBack'
import { ManagerDetailsPageController } from './ManagerDetailsPageController'
import { Spinner } from '@/view/components/ui/spinner'
import React from 'react'
import { SupervisorsCard } from '../../Supervisores/components/SupervisorsCard'
import { Button } from '@/view/components/ui/button'

export const ManagerDetailsPage = () => {
  const {
    data,
    isLoading,
    managerName,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    ref,
  } = ManagerDetailsPageController()

  return (
    <div>
      <div style={{ display: 'inline-block' }}>
        <ButtonBack label={managerName} />
      </div>
      {isLoading ? (
        <div className="mt-8 flex items-center justify-center">
          <Spinner />
        </div>
      ) : (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(386px, 1fr))',
            gap: '16px',
          }}
        >
          {data &&
            data.pages.map((page, pageIndex) => (
              <React.Fragment key={pageIndex}>
                {page.data.map((supervisor) => (
                  <SupervisorsCard key={supervisor._id} {...supervisor} />
                ))}
              </React.Fragment>
            ))}
        </div>
      )}
      <div className="mt-2 flex items-center justify-center" ref={ref}>
        <Button variant="ghost" disabled={!hasNextPage || isFetchingNextPage}>
          {isFetchingNextPage ? <Spinner /> : null}
        </Button>
      </div>

      {isFetching && !isFetchingNextPage && !isLoading ? (
        <div className="mt-4 flex items-center justify-center">
          <Spinner />
        </div>
      ) : null}
    </div>
  )
}
